import * as React from 'react';
import { Checkbox, FormControl, HelpBlock, InputGroup, Radio } from 'react-bootstrap';
import * as Cleave from 'cleave.js/react';
import {filterCurrency, filterNumber} from '../../util/validators';
import NameField from '../NameField';
import {CleaveOptions} from 'cleave.js/options';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');
// Work around the module being used in CJS and ES6 module formats.
// One module exports with a default, the other doesn't...
let MaskedInput = require('react-text-mask');

if (MaskedInput.default) {
  MaskedInput = MaskedInput.default;
}

const defaultCleaveOptions: CleaveOptions = {};

const FieldFormControl = ({
  placeholder = '',
  type = '',
  formControlType = '',
  input= {},
  componentClass = 'input',
  className = '',
  style = {},
  meta = {error, touched},
  // mask,
  value = '',
  addOn = '',
  currency = false,
  addOnRight = '',
  addOnClassName = [''],
  complexValue = false,
  simpleValue = null,
  cleaveOptions = defaultCleaveOptions,
  disabled = false,
  isNumber = false,
  isFloat = false,
  readOnly = false,
  ...props,
}) => {

  const classes = className + (meta.dirty ? ' dirty-field' : '') + ' sessioncamhidetext';
  let component = null;
  let onBlur = input.onBlur;
  let onChange = input.onChange;

  if (complexValue) {
    onBlur = () => input.onBlur();
    onChange = () => input.onChange(input.value);
  }

  const complexProps = { onBlur, onChange, value: input.value };

  // if (complexValue) {
  //   complexProps.value = simpleValue;
  // }

  let options: CleaveOptions = null;

  switch (type) {
    case 'masked-date':
      options = {
        date: true,
        datePattern: ['d', 'm', 'Y'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          {...input}
          {...props}
          readOnly={readOnly}
        />
      );
      break;
    case 'expiry-date':
      options = {
        date: true,
        datePattern: ['m', 'Y'],
      };

      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={options}
          {...input}
          {...props}
        />
      );
      break;
    case 'cleave':
      component = (
        <Cleave
          style={style}
          className={classes + ' form-control'}
          placeholder={placeholder}
          options={cleaveOptions}
          {...input}
          {...props}
        />
      );
      break;
    case 'checkbox':
      component = <Checkbox style={style} className={classes} {...input} {...props} {...complexProps} />;
      break;
    case 'radio':
      component = (
        <Radio
          style={style}
          disabled={disabled}
          className={classes}
          value={value}
          {...input}
          {...props}
          {...complexProps}
        />
      );
      break;
    case 'inputGroup':
      let value = input.value;

      if (currency) {
        value = filterCurrency(value, ' ');
      }
      if (isNumber) {
        value = filterNumber(value, isFloat);
      }
      component = (
        <InputGroup>
          {addOn && (
            <InputGroup.Addon className={addOnClassName.join(' ')}>{addOn}</InputGroup.Addon>
          )}
          <FormControl
            {...input}
            style={style}
            placeholder={placeholder}
            componentClass={componentClass}
            className={classes}
            value={value}
            disabled={disabled}
            type={formControlType ? formControlType : 'text'}
          />
          {addOnRight && (
            <InputGroup.Addon className={addOnClassName.join(' ')}>{addOnRight}</InputGroup.Addon>
          )}
        </InputGroup>
      );
      break;
    case 'textarea':
      component = (
        <textarea
          style={style}
          className={classes + ' form-control'}
          value={value}
          {...input}
          {...props}
          {...complexProps}
        />);
      break;
    case 'namefield':
      component = (
        <NameField
          {...props}
        />
      );
      break;
    default:
      component = (
        <FormControl
          style={style}
          type={type}
          placeholder={placeholder}
          componentClass={componentClass}
          className={classes}
          disabled={disabled}
          {...input}
          {...props}
          {...complexProps}
        />
      );
      break;
  }

  // meta.error = 'Error test';

  const hasError = meta.touched && meta.submitFailed && meta.error;
  return (
    <div className={hasError ? 'has-error' : ''}>
      {component}
      {hasError && <HelpBlock><FaInfoCircle /><strong>{' '}{meta.error}</strong></HelpBlock>}
    </div>
  );
};

export default FieldFormControl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/FieldFormControl/index.tsx